<h1 class="color-serfor">Formulario de Usuarios</h1>

<form class="container" [formGroup]="userForm">
  <div
    fxLayout="row wrap"
    fxLayoutAlign="left"
    fxLayoutGap="10px"
    fxLayoutGap.xs="0"
  >
    <mat-form-field appearance="fill" fxFlex="40%">
      <mat-label>Nombres Completos</mat-label>
      <input
        matInput
        class="form-control"
        id="nombreCompleto"
        name="nombreCompleto"
        formControlName="nombreCompleto"
        [(ngModel)]="user.clientName"
      />
      <!--<mat-error *ngIf="id.invalid">{{getErrorMessage()}}</mat-error>-->
    </mat-form-field>
  </div>

  <div
    fxLayout="row wrap"
    fxLayoutAlign="left"
    fxLayoutGap="10px"
    fxLayoutGap.xs="0"
  >
    <mat-form-field appearance="fill" fxFlex="40%">
      <mat-label>Correo</mat-label>
      <input
        matInput
        class="form-control"
        id="correo"
        formControlName="correo"
        [(ngModel)]="user.correo"
      />
      <!--<mat-error *ngIf="id.invalid">{{getErrorMessage()}}</mat-error>-->
    </mat-form-field>
  </div>

  <div
    fxLayout="row wrap"
    fxLayoutAlign="left"
    fxLayoutGap="10px"
    fxLayoutGap.xs="0"
  >
    <mat-form-field appearance="fill" fxFlex="40%">
      <mat-label>Password</mat-label>
      <input
        matInput
        class="form-control"
        id="pass"
        formControlName="pass"
        [(ngModel)]="user.pass"
      />
      <!--<mat-error *ngIf="id.invalid">{{getErrorMessage()}}</mat-error>-->
    </mat-form-field>
  </div>


  <div
    fxLayout="row wrap"
    fxLayoutAlign="left"
    fxLayoutGap="10px"
    fxLayoutGap.xs="0"
    >

    <table class="tb-permisos" >

      <tr>

        <td></td>
        <td>REG</td>
        <td>APR</td>
        <td>PUB</td>

      </tr>

      <tr *ngFor="let so of arrTematicas; let i = index">

        <td>{{so.tematica}}</td>
        <td>
            <mat-checkbox #checkBoxReg [checked]="existeReg(so.sqTematica)" [value]="so.sqTematica" (change)="toggleReg(checkBoxReg)"></mat-checkbox>
        </td>
        <td>
          <mat-checkbox #checkBoxApr [checked]="existeApr(so.sqTematica)" [value]="so.sqTematica" (change)="toggleApr(checkBoxApr)"></mat-checkbox>
        </td>
        <td>
          <mat-checkbox #checkBoxPub [checked]="existePub(so.sqTematica)" [value]="so.sqTematica" (change)="togglePub(checkBoxPub)"></mat-checkbox>
        </td>

      </tr>

    </table>

  </div>


  <div
    fxLayout="row wrap"
    fxLayoutAlign="left"
    fxLayoutGap="10px"
    fxLayoutGap.xs="0"
  >
    <div fxFlex="15%" class="button-flex-container">
      <button
        mat-button
        mat-raised-button
        color="primary"
        [disabled]="this.userForm.invalid"
        (click)="registrarUsuario()"
      >
        Registrar Usuario
      </button>
    </div>

    <div fxFlex="15%" class="button-secondary-container">
      <button mat-button (click)="retornarListado()">Cancelar</button>
    </div>
  </div>
</form>
